module.exports = __webpack_public_path__ + "files/d6cf20696d8fc34ecda12567298d5fee.svg";